import gql from 'graphql-tag';

export default gql`
    mutation EditAssetLoadProgress($input: EditAssetLoadProgressInput) {
        editAssetLoadProgress(input: $input) {
            errors
        }
    }
`;
